import { appModulesG4De } from './golf4App.de.js';
// Duits (de-DE), modulesApp: zelfde vorm als modulesApp.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appModulesDe = {
    ...appModulesG4De,
    title: 'Module',
    intro: 'Wähle, welche Bereiche ihr nutzt. Ausschalten löscht nichts: Schaltest du etwas wieder ein, ist noch alles da.',
    settingsBody: 'Bereiche ein- oder ausschalten, zum Beispiel Bringen und Abholen',
    on: 'An',
    off: 'Aus',
    dependsOn: 'Funktioniert nur, wenn {names} an ist.',
    offBecause: 'Aus ({names} ist aus)',
    exampleA: 'Lena',
    exampleB: 'Jonas',
    holidaysIslamic: 'Auch Zuckerfest und Opferfest nach eurer Tradition.',
    blockedBy: 'Ist aus, weil {names} aus ist.',
    alsoOff: 'Damit wird auch {names} ausgeschaltet.',
    notInPlan: 'Nicht in eurem Abo enthalten.',
    settings: 'Einstellungen',
    /** WP3: toegankelijke naam van het tandwiel bij een module. */
    settingsOf: 'Einstellungen für {name}',
    // Golf 6b (0043): modules die niet bij de soort huishouden passen, en de soort zelf.
    showAll: 'Alle Module zeigen',
    showFewer: 'Nur was zu uns passt',
    hiddenNote: 'Teile, die nicht zu eurer Art von Haushalt passen, sind ausgeblendet.',
    typeLine: 'Art des Haushalts: {name}',
    typeChange: 'Ändern',
    toastOn: '{name} ist an',
    toastOff: '{name} ist aus. Es wurde nichts gelöscht.',
    toastOption: 'Gespeichert',
    optionNeeds: 'Funktioniert, wenn {name} an ist.',
    onlyParents: 'Nur ein Elternteil kann das ändern.',
    kioskNote: 'Das Tablet passt sich innerhalb weniger Sekunden an.',
    groups: {
        agenda: 'Kalender und unterwegs',
        home: 'Zuhause und gemeinsam',
        personal: 'Persönlich',
        faith: 'Glaube und Tradition',
        board: 'Board und App',
        care: 'Pflege und Familie',
    },
    groupCount: '{on} von {total} an',
    search: 'Modul suchen',
    searchNone: 'Kein Modul gefunden für „{q}“.',
    options: 'Optionen ({n})',
    offTitle: '{name} ist aus',
    offBody: 'Dieser Bereich ist für eure Familie ausgeschaltet. Es wurde nichts gelöscht.',
    offBodyChild: 'Dieser Bereich ist aus. Frag Mama oder Papa, ob sie ihn einschalten.',
    offAction: 'Zu den Modulen',
    rides: {
        dropoff: '{name} bringt',
        pickup: '{name} holt ab',
        both: '{name} bringt und holt ab',
        whoDropoff: 'Wer bringt?',
        whoPickup: 'Wer holt ab?',
        travel: '{minutes} Min. unterwegs',
        travelWho: '{name} fährt · {minutes} Min.',
        /** 0056: smal blokje ná de afspraak (de weg terug). */
        travelBack: '{minutes} Min. zurück',
    },
};
//# sourceMappingURL=modulesApp.de.js.map